/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React from "react";
import { InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";

export default function ProfileSelect({
  label,
  isItemLoading,
  selectedValue,
  handleSelectValue,
  options,
}) {
  return (
    <>
      <InputLabel
        id="profile-label"
        sx={{ display: "flex", alignItems: "center" }}
      >
        {label}
        {isItemLoading && <CircularProgress size={20} sx={{ ml: "10px" }} />}
      </InputLabel>
      <Select
        labelId="profile-label"
        fullWidth
        value={selectedValue}
        onChange={handleSelectValue}
        required
        sx={{ mt: "10px" }}
      >
        {options.map((item) => (
          <MenuItem value={item.value} key={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}
